// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Lang
import { nsSimCard } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.cellData
 * @param root0.dataUnit
 * @returns {JSX} CustomPayRenderDataUnit
 */
function CustomPayRenderDataUnit({ cellData, dataUnit }) {
    return (
        <div>
            <span>{cellData}</span>
            <Entity entity={`units.${dataUnit}`} namespace={nsSimCard} className='mx-1' />
        </div>
    );
}

CustomPayRenderDataUnit.propTypes = {
    cellData: PropTypes.number,
    dataUnit: PropTypes.string
};
export default CustomPayRenderDataUnit;